var _defs, _g, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCursor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cursor_empty",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.221,
    height: 61.898,
    viewBox: "0 0 41.221 61.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_2",
    x: 2.389,
    y: 28.712,
    width: 36.441,
    height: 33.187,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cursor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Polygon_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_2-2",
    "data-name": "Polygon 2",
    transform: "translate(29.83 49.9) rotate(180)",
    fill: "#306e57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.66386222839355 14.1865234375 L 1.77703070640564 14.1865234375 L 9.220446586608887 1.926863431930542 L 16.66386222839355 14.1865234375 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.220446586608887 3.853706359863281 L 3.554055213928223 13.1865234375 L 14.88683795928955 13.1865234375 L 9.220446586608887 3.853706359863281 M 9.220446586608887 3.814697265625e-06 L 18.44089698791504 15.1865234375 L -3.814697265625e-06 15.1865234375 L 9.220446586608887 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#345f5a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    fill: "#306e57",
    stroke: "#345f5a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.221,
    height: 40.136,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 39.221,
    height: 38.136,
    rx: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M6.866,0l6.866,11.136H0Z",
    transform: "translate(27.476 45.848) rotate(-180)",
    fill: "#306e57"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(12.61 12.848)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.c4e99a369b3d92992b0ac02b17a93c12.svg";
export { ForwardRef as ReactComponent };